<!-- PedidosFiltros.vue — Barra de búsqueda y filtros de la tabla principal -->
<template>
  <div class="divisan-card mb-4 p-3 shadow-sm">
    <div class="row g-3 align-items-center">
      <div class="col-12 col-md-5">
        <div class="search-wrapper">
          <i class="bi bi-search"></i>
          <input
            :value="filtro"
            @input="$emit('update:filtro', $event.target.value)"
            type="text"
            class="form-control divisan-input"
            placeholder="# pedido o cliente..."
          />
        </div>
      </div>
      <div class="col-12 col-md-3">
        <select
          :value="filtroEstatus"
          @change="$emit('update:filtroEstatus', $event.target.value)"
          class="form-select divisan-input"
        >
          <option value="">Estatus</option>
          <option value="En proceso">En proceso</option>
          <option value="Listo para entrega">Listo</option>
          <option value="Entregado">Entregado</option>
          <option value="Cancelado">Cancelado</option>
        </select>
      </div>
      <div class="col-12 col-md-3">
        <select
          :value="filtroPrioridad"
          @change="$emit('update:filtroPrioridad', $event.target.value)"
          class="form-select divisan-input"
        >
          <option value="">Prioridad</option>
          <option value="Alta">Alta</option>
          <option value="Media">Media</option>
          <option value="Baja">Baja</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  filtro: { type: String, default: "" },
  filtroEstatus: { type: String, default: "" },
  filtroPrioridad: { type: String, default: "" },
});
defineEmits(["update:filtro", "update:filtroEstatus", "update:filtroPrioridad"]);
</script>

<style scoped>
.divisan-card {
  background-color: var(--d-cream);
  border-radius: 12px;
  border-left: 5px solid var(--d-green);
}
.divisan-input {
  background-color: white !important;
  border: 1px solid var(--d-green);
  color: var(--d-brown) !important;
}
.divisan-input::placeholder {
  color: rgba(64, 34, 8, 0.4);
}
.search-wrapper {
  position: relative;
}
.search-wrapper > i {
  position: absolute;
  left: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: var(--d-green);
  pointer-events: none;
}
.search-wrapper input {
  padding-left: 35px;
}
</style>
